module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24528/sass/messagesWidgetShell.sass"